import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/ucenter/ucenter.vue'
wx.createPage(MiniProgramPage)